import React from "react";
import { FiAlertCircle, FiEye, FiMessageSquare, FiTrendingUp } from "react-icons/fi";
import "./HRCopilotRequirementSection.css";

const HRCopilotSolutionSection = () => {
  return (
    <div className="sol-wrapper">
      <div className="sol-overlay"></div>

      <div className="sol-container">

        <p className="sol-subtitle">MORE THAN JUST HR</p>

        <h1 className="sol-title">
          <span className="sol-title-red">From your problem</span>
          <span className="sol-title-dark">To sustainable solution</span>
        </h1>

        <p className="sol-description">
          HRCopilot converts manual HR tasks into streamlined automated workflows.
          Reduce bottlenecks, improve communication, and achieve error-free HR operations.
        </p>

        {/* 4 Steps */}
        <div className="sol-steps">

          {/* Step 1 */}
          <div className="sol-step-card">
            <div className="sol-icon red">
              <FiAlertCircle size={38} />
            </div>
            <p className="sol-step-label">STEP 1</p>
            <h3 className="sol-step-title">Your Problem</h3>
            <p className="sol-step-text">
              Struggling with manual onboarding, missing documents, unclear processes,
              and repeated follow-ups? We identify the friction points in your HR workflow.
            </p>
          </div>

          {/* Step 2 */}
          <div className="sol-step-card">
            <div className="sol-icon dark">
              <FiEye size={38} />
            </div>
            <p className="sol-step-label">STEP 2</p>
            <h3 className="sol-step-title">Our Observation</h3>
            <p className="sol-step-text">
              We analyze task delays, document gaps, communication issues,
              and access restrictions that affect HR productivity.
            </p>
          </div>

          {/* Step 3 */}
          <div className="sol-step-card">
            <div className="sol-icon red">
              <FiMessageSquare size={38} />
            </div>
            <p className="sol-step-label">STEP 3</p>
            <h3 className="sol-step-title">Our Suggestions</h3>
            <p className="sol-step-text">
              We propose automated workflows, centralized document handling,
              smart reminders, and approval-based task systems tailored to your HR needs.
            </p>
          </div>

          {/* Step 4 */}
          <div className="sol-step-card">
            <div className="sol-icon dark">
              <FiTrendingUp size={38} />
            </div>
            <p className="sol-step-label">STEP 4</p>
            <h3 className="sol-step-title">Your Success</h3>
            <p className="sol-step-text">
              With HRCopilot automation, HR becomes faster, accurate, transparent,
              and fully trackable—boosting team efficiency and employee experience.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HRCopilotSolutionSection;
